var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length > 0)?_c('div',{staticClass:"mb-2"},[_c('h3',{staticClass:"subcategory__name mb-3"},[_vm._v(_vm._s(_vm.$t(_vm.name)))]),_vm._l((_vm.items),function(item,index){return _c('menu-item',_vm._b({key:index,attrs:{"full-width-info":_vm.showFullWidthInfo}},'menu-item',item,false))})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }